import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { useSignups } from "Signups/state.js";

import FnrProgressBar from "UI/FnrProgressBar2";

import { useIsSignedUpForAnyItem } from "./utils/useIsSignedUpForAnyItem";

ProgressBarAreaPollType.propTypes = {
  signupItem: PropTypes.object,
};

export default function ProgressBarAreaPollType({ signupItem }) {
  const [state] = useSignups();
  const { slotsTaken } = signupItem;
  const isPlural = slotsTaken !== 1;

  const isSignedUpForAnyItem = useIsSignedUpForAnyItem();

  // only show if they have already voted
  if (!isSignedUpForAnyItem) return <Hidden />;

  const highestNumberOfVotes = state.currentSignupList.signupItems?.sort(
    (a, b) => (a.slotsTaken < b.slotsTaken ? 1 : -1)
  )[0].slotsTaken;

  if (signupItem?.showRespondentsCount === false) return null;

  return (
    <Wrapper>
      <Labels>
        <Label>
          {slotsTaken} {isPlural ? "votes" : "vote"}
        </Label>
      </Labels>
      <FnrProgressBar
        count={slotsTaken}
        max={highestNumberOfVotes}
        delay={0.4}
      />
    </Wrapper>
  );
}

const Hidden = styled.div`
  margin-top: -20px;
`;

const Wrapper = styled.div`
  margin: 10px 0;
  position: relative;
`;

const Labels = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 4px;
`;

const Label = styled.div`
  opacity: 0.69;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  color: #2f3f4f;
  letter-spacing: -0.04px;
`;
